import { feats, perks, weapons, weaponEnchantments, armor, armorEnchantments, spells, maneuvers, classRoll, potions, ragePerks, roguePerks, fighterPerks, kiPerks, gambits, recoveryPerks, metamagic, stats, rarities, spellRarities, maneuverTypeRarities, skills, alignments, drawbacks, gear, wonderousItems, featRarities, statRarities, races } from "./data";
import {comboTagsWithExtra as comboTags, comboTagText,tagToSchool} from "./constants.js"
export default {        
    roll(type, options, count, playerFeats, playerPerks, playerNames) {
        switch (type) {
            case 'feats':
                return this.rollFeat(options, count, playerFeats, playerNames, playerPerks)
            case 'perks':
                return this.rollPerk(options, playerPerks, count)
            case 'weapon':
                return this.rollWeapon(options, count)
            case 'weaponEnchantments':
                return this.rollWeaponEnchantment(options, count)
            case 'armor':
                return this.rollArmor(options, count)
            case 'armorEnchantments':
                return this.rollArmorEnchantments(options, count)
            case 'spells':
                return this.rollSpells(options, count)
            case 'maneuver':
                return this.rollManeuver(options, count)
            case 'stats':
                return this.rollStats(options, count)
            case 'levelUp':
                return this.levelUp(options, count)
            case 'class':
                return this.rollClass(parseInt(count) + 3)
            case 'gold':
                return this.rollGold(options, count)
            case 'store':
                return this.rollStore(options, count)
            case 'potions':
                return this.rollPotions(options, count)
            case 'loot':
                return this.rollLoot(options)
            case 'alignment':
                return this.rollAlignment(count)
            case 'gear':
                return this.rollGear(options)
            case 'wonderousItems':
                return this.rollWonderousItems(options, count)
            case 'metamagicRod':
                return this.rollMetamagicRod(options)
            case 'masterworkTool':
                return this.rollMasterworkTool(options)
            case 'race':
                return this.rollRace(count)
        }
    },

    rollFeat(options, count, playerFeats, playerNames, playerPerks) {
        let prereq = false
        if(options.prereq){
            prereq = true
            options.prereq = false
        }
        let optionsArr = []
        Object.entries(options).forEach((entry) => {
            if (entry[1] == true) {
                optionsArr.push(entry[0])
            }
        })
        let totalList = feats.concat(metamagic)
        if(options.key){
            totalList = totalList.filter(feat => feat.key && feat.key == true)
            if(prereq) totalList = totalList.filter(feat=> !feat.perkPrereq && !feat.prereq)
        }else{
            for (let x = 0; x < totalList.length; x++) {
                let feat = totalList[x]
                if(playerFeats && playerFeats.includes(feat.name)){
                    totalList.splice(x,1)
                    x--
                    continue
                }
                if(feat.prereq && playerFeats && !playerFeats.includes(feat.prereq)){
                    totalList.splice(x,1)
                    x--
                    continue
                }
                if(feat.perkPrereq && playerPerks && !playerPerks.some(perk => feat.perkPrereq.includes(perk))){
                    totalList.splice(x,1)
                    x--
                    continue
                }
            }
        }
        

        let choices = []        
        let rarityArr = this.getOptionsArray(options)
        let chosen = []
        for (let x = 0; x < count*2; x++) {
            let choice
            let rarity = this.getRarity(rarityArr, featRarities)
            if(Math.random() > 0.85 || prereq){
                let refinedPossibilities = totalList.filter(feat=> (feat.prereq || (feat.featRateUp && playerFeats.some(playerFeat => feat.featRateUp.includes(playerFeat)))) && rarityArr.includes(feat.type) && !chosen.includes(feat.name))
                console.log("perk feats", totalList.filter(feat=> (feat.perkPrereq || (feat.perkRateUp && playerPerks.some(perk => feat.perkRateUp.includes(perk)))) && rarityArr.includes(feat.type) && !chosen.includes(feat.name)))
                refinedPossibilities = refinedPossibilities.concat(totalList.filter(feat=> (feat.perkPrereq || (feat.perkRateUp && playerPerks.some(perk => feat.perkRateUp.includes(perk)))) && rarityArr.includes(feat.type) && !chosen.includes(feat.name)))
                if(refinedPossibilities.length > 0){
                    let random = refinedPossibilities[Math.floor(Math.random() * refinedPossibilities.length)]
                    chosen.push(random.name)
                    choice = JSON.parse(JSON.stringify(random))
                }
            }
            if(!choice){
                let refinedPossibilities = totalList.filter(feat=> feat.type == rarity)
                choice = JSON.parse(JSON.stringify(refinedPossibilities[Math.floor(Math.random() * refinedPossibilities.length)]))
            }
            if(choice.type == "teamwork"){
                choice.playerNames = playerNames
            }
            choice.id = Math.random() * 10000000000           
            choices.push(choice);
        }
        return choices;
    },

    rollPerk(options, playerPerks, count) {
        let rarityArr = this.getOptionsArray(options.rarity)
        let typeArr = this.getOptionsArray(options.type)
        let sub
        let choices = []
        Object.entries(options.sub).forEach((entry) => {
            if (entry[1] == true) {
                sub = entry[0]
            }
        })
        if(sub){
            for(let x = 0; x < count; x++){
               let choice = this.rollSubPerk(sub, playerPerks, options.prereq)
               choice.rarity = "rare" 
               choices.push(choice)
            }
            return choices
        }
        let possibilities = []        
        for (let x = 0; x < perks.length; x++) {
            if (rarityArr.includes(perks[x].rarity) && typeArr.includes(perks[x].type)) {
                possibilities.push(perks[x])
            }
        }
        for (let x = 0; x < count; x++) {      
            if(Math.random() < 0.0025 || rarityArr.includes("forbidden")){
                let possibilities = perks.filter(possibility => possibility.rarity == "forbidden")
                let choice = JSON.parse(JSON.stringify(possibilities[Math.floor(Math.random() * possibilities.length)]))
                choice.id = Math.random() * 1000000000
                choices.push(choice)
                console.log("Forbidden perk has been rolled. Woe To all who play this game")
                continue
            }
            let type = typeArr[Math.floor(Math.random()*typeArr.length)]
            let rarity = this.getRarity(rarityArr, rarities)
            let refinedPossibilities = possibilities.filter(possibility => possibility.rarity == rarity && ((rarity == "unique" && typeArr.includes(perks[x].type)) || possibility.type == type) && (!possibility.prereq || playerPerks.includes(possibility.prereq)))
            if(Math.random() > 0.9 || options.prereq){
                let possiblePreqs = possibilities.filter(possibility => (playerPerks.includes(possibility.prereq) || playerPerks.includes(possibility.rateUp)) && !playerPerks.includes(possibility.name))
                if(possiblePreqs.length > 0){
                    refinedPossibilities = possiblePreqs
                }
            }
            let choice = JSON.parse(JSON.stringify(refinedPossibilities[Math.floor(Math.random() * refinedPossibilities.length)]))
            let subPerksNames = ["ragePerks","kiPerks","recoveryPerks","roguePerks","fighterPerks"]
            subPerksNames.forEach((sub)=>{
                if(sub == choice.shortDesc){
                    choice = this.rollSubPerk(sub, playerPerks, options.prereq)
                    choice.type = sub
                    choice.rarity = "rare"
                }
            })                      
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },
    rollSubPerk(sub, playerPerks, prereq){
        let subList = JSON.parse(JSON.stringify({kiPerks, fighterPerks, roguePerks, gambits, ragePerks,recoveryPerks}))        
        if(sub =="ragePerks"){
            if(playerPerks && (!playerPerks.includes("Rage") && !playerPerks.includes("Epic Rage"))){
                subList.ragePerks = subList.ragePerks.filter(ragePerk => ragePerk.type == "universal") 
            }
        }
        subList = subList[sub].filter(possibility => !possibility.prereq || (possibility.prereq && playerPerks && playerPerks.includes(possibility.prereq)))
        if(Math.random() > 0.9 || prereq){
            let possibleSubList = subList.filter(possibility => (playerPerks.includes(possibility.prereq) || playerPerks.includes(possibility.rateUp)) && !playerPerks.includes(possibility.name))
            if(possibleSubList.length > 0){
                subList = possibleSubList
            }
        }

        let roll = subList[Math.ceil(Math.random() * subList.length-1)]
        if(roll.shortDesc == "gambits"){
            roll = this.rollSubPerk("gambits", playerPerks, prereq)
            roll.type = "gambits"
            roll.rarity = "rare"
        }
        let result = JSON.parse(JSON.stringify(roll))
        return result
    },
    rollWeapon(optionsdef, count) {
        let options = JSON.parse(JSON.stringify(optionsdef))
        let rarityArr = this.getOptionsArray(options.weapon.rarity)
        let typeArr = this.getOptionsArray(options.weapon.type)
        //let classArr = this.getOptionsArray(options.weapon.class)
        let choices = []

        let possibilities = []
        if(!options.name){
            for (let x = 0; x < weapons.length; x++) {
                if (typeArr.includes(weapons[x].type)) {
                    possibilities.push(weapons[x])
                }            
            }
        }else{
            possibilities = weapons.filter(weapon => weapon.name == options.name)
        }

        let originalClassOptions = options.class
        for (let x = 0; x < count; x++) {
            let rarity = this.getRarity(rarityArr, rarities)
            let type = typeArr[Math.floor(Math.random()*typeArr.length)]
            if(options.name){
                rarity = possibilities[0].rarity
                type = possibilities[0].type
            }
            
            let enchantmentCount = options.weapon.class.enchanted ? 1 : 0
            if(Math.random() > 0.95){                
                enchantmentCount += 1
            }
            let refinedPosibilities = possibilities.filter(posibility => posibility.rarity == rarity && posibility.type == type)
            let choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.floor(Math.random() * refinedPosibilities.length)]))
            choice.enchantments = []
            if(enchantmentCount != 0){
                let specifyArr = this.getOptionsArray(options.weaponEnchantments.class)
                specifyArr.forEach((weaponClass) => options.weaponEnchantments.class[weaponClass] = false)
                options.weaponEnchantments.class[choice.class] = true
                options.weaponEnchantments.class['all'] = true
                choice.enchantments = this.rollWeaponEnchantment(options, enchantmentCount)
            }
            options.class = originalClassOptions
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },
    rollWeaponEnchantment(options, count) {        
        let choices = []
        let rarityArr = this.getOptionsArray(options.weaponEnchantments.rarity)
        let classArr =  this.getOptionsArray(options.weaponEnchantments.class)
        let possibilities = weaponEnchantments.filter(weaponEnchantment => rarityArr.includes(weaponEnchantment.rarity) && (classArr.includes(weaponEnchantment.class) || weaponEnchantment.class == 'all' || (["ranged","armament"].includes(classArr) && weaponEnchantment.class == "rangement") ))
        for(let x = 0; x < count; x++){
            let rarity = this.getRarity(rarityArr, rarities)
            let refinedPosibilities = possibilities.filter(posibility => posibility.rarity == rarity)
            let enhancement = Math.random() < 0.25
            if(enhancement){
                refinedPosibilities = refinedPosibilities.filter(possibility => possibility.name.includes("+"))
            }
            let choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.floor(Math.random() * refinedPosibilities.length)]))
            choice.id = Math.random() * 1000000000
            if(choice.name == "Training"){
                let feat = this.rollFeat({martial:true}, 1, [], [], [])
                choice.shortDesc += `\n\n`
                choice.shortDesc += feat[0].name + `: `
                choice.shortDesc += `\n`
                choice.shortDesc += feat[0].longDesc.length != 0 ? feat[0].longDesc : feat[0].shortDesc 
            }
            if(choice.multiSelect){
                let multiSelect = choice.multiSelect[Math.floor(Math.random() * choice.multiSelect.length)]
                choice.shortDesc += `\n\nType: ` + multiSelect
                if(choice.multiSelectTypes){
                    choice.multiSelectTypes.forEach((multiSelectType)=>{
                        choice[multiSelectType.type][multiSelectType.index].type = multiSelect
                    })
                }
            }
            choices.push(choice)
        }
        return choices
    },
    rollArmor(options, count) {
        let typeArr = this.getOptionsArray(options.armor.type)
        let rarityArr = this.getOptionsArray(options.armor.rarity)
        let choices = []
        let possibilities = []        
        for (let x = 0; x < armor.length; x++) {
            if (typeArr.includes(armor[x].type)) {
                possibilities.push(armor[x])
            }
        }
        for (let x = 0; x < count; x++) {
            let type = typeArr[Math.floor(Math.random()*typeArr.length)]
            let rarity = "none"
            if(!["shield","clothing"].includes(type)){
                rarity = this.getRarity(rarityArr, rarities)
            }
            let enchantmentCount = options.armor.enchanted ? 1 : 0      
            if(Math.ceil(Math.random() * 100 -1) > 94) enchantmentCount += 1
            let refinedPosibilities = possibilities.filter(possibility => possibility.type == type && possibility.rarity == rarity)
            let choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.floor(Math.random() * refinedPosibilities.length)]))
            choice.enchantments = []
            if(enchantmentCount > 0){
                choice.enchantments = this.rollArmorEnchantments(options, enchantmentCount)
            }
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },
    rollArmorEnchantments(options, count) {     
        let choices = []
        let rarityArr = this.getOptionsArray(options.armorEnchantments)
        //let possibilities = []
        for(let x = 0; x < count; x++){
            let rarity = this.getRarity(rarityArr, rarities)
            let choice = []
            let enhancement = Math.random() < 0.34
            let refinedPosibilities = armorEnchantments.filter(possibility => possibility.rarity == rarity)
            if(enhancement){
                refinedPosibilities = refinedPosibilities.filter(possibility => possibility.name.includes("+"))
            }
            choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.floor(Math.random() * refinedPosibilities.length)]))
            choice.id = Math.random() * 1000000000 
            choices.push(choice)
        }
        return choices
    },
    rollSpells(options, count) {
        let allSpells = [...spells]
        let choices = []
        let rarityArr = this.getOptionsArray(options.level).map(level=> level.substring(3,4))
        let typeArr = this.getOptionsArray(options.type)        
        for(let x = 0; x < count; x++){
            if(options.tags){
                allSpells = allSpells.filter(spell=> {
                    for(let y = 0; y < options.tags.length; y++){
                        if(spell.tags && spell.tags.includes(options.tags[y])) return true
                    }                
                })
            }

            if(options.school){
                allSpells = allSpells.filter(spell=>spell.school.includes(options.school))
            }

            let level = this.getLevelRarity(rarityArr)
            let type = typeArr[Math.floor(Math.random() * typeArr.length)]
            let refinedPosibilities             
            if(!options.tags && !options.school){
                refinedPosibilities = allSpells.filter(possibility=> possibility.level == level && possibility.type.includes(type))               
            }else if(options.tags){
                refinedPosibilities = allSpells.filter(possibility=> possibility.level == level)
                let x = 0
                while(refinedPosibilities.length < 1){
                    x++
                    level = this.getLevelRarity(rarityArr)                    
                    refinedPosibilities = allSpells.filter(possibility=> possibility.level == level)
                    if(x == 9){
                        break
                    }
                }
            }else{
                refinedPosibilities = allSpells.filter(possibility=> possibility.level == level)
            }
            let choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.floor(Math.random() * refinedPosibilities.length)]))
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },
    rollManeuver(options, count) {
        let choices = []
        let levels = this.getOptionsArray(options.level).map(level=> parseInt(level.substring(3,4)))
        let schools = this.getOptionsArray(options.school)
        let types = this.getOptionsArray(options.type)
        
        let wasComboTags = false
        let originalSchools = schools
        if(!options.onlyFinisher && comboTagText.some(tag=>schools.includes(tag))){
            wasComboTags = true
            let createdSchools = []
            schools.forEach(tag=>{
                createdSchools = createdSchools.concat(tagToSchool[tag])
            })
            schools = createdSchools
        }

        for(let x = 0; x < count; x++){
            let type = this.getRarity(types, maneuverTypeRarities)
            let school = schools[Math.floor(Math.random()*schools.length)]

            if(type == "Finisher"){
                let maxLevel = levels.sort().reverse()[0]
                let filteredManeuvers = maneuvers.filter(maneuver=> !maneuver.gameOnly)
                if(options.onlyFinisher){
                    filteredManeuvers = maneuvers.filter(maneuver=> maneuver.type == "Finisher" 
                                                                    && maneuver.level <= maxLevel 
                                                                    && (maneuver.comboTags && maneuver.comboTags.includes(school)))
                }else{
                    filteredManeuvers = maneuvers.filter(maneuver=> maneuver.type == "Finisher" 
                                                                    && maneuver.level <= maxLevel && 
                                                                    (
                                                                        (maneuver.school && maneuver.school == school) || 
                                                                        (wasComboTags && maneuver.comboTags && maneuver.comboTags.some(tag => originalSchools.includes(tag))) ||
                                                                        (!wasComboTags && maneuver.comboTags && maneuver.comboTags.some(tag => comboTags[school].includes(tag)))
                                                                    ))
                }

                let choice = JSON.parse(JSON.stringify(filteredManeuvers[Math.floor(Math.random() * filteredManeuvers.length)]))
                choice.id = Math.random() * 1000000000
                choices.push(choice)
            }else{
                let filteredTypes = types.filter(type=> type != "Finisher")
                let filteredManeuvers
                
                if(options.includeSubschool){
                    filteredManeuvers = maneuvers.filter(possibility => possibility.school == school && (!possibility.subSchool || possibility.subSchool.includes(options.includeSubschool)))
                }else if(options.onlySubschool){
                    filteredManeuvers = maneuvers.filter(possibility => possibility.school == school && possibility.subSchool && possibility.subSchool.includes(options.onlySubschool))
                }else{
                    filteredManeuvers = maneuvers.filter(maneuver => maneuver.school == school && levels.includes(maneuver.level) && filteredTypes.includes(maneuver.type))
                }

                let validLevels = levels.filter(level=> filteredManeuvers.some(maneuver=> maneuver.level == level))
                let level = this.getLevelRarity(validLevels)
                filteredManeuvers = filteredManeuvers.filter(maneuver=> maneuver.level == level)
                let validTypes = new Set(filteredManeuvers.map(maneuver=>maneuver.type))
                let type = this.getRarity(validTypes, maneuverTypeRarities)
                filteredManeuvers = filteredManeuvers.filter(maneuver=> maneuver.type == type)

                let choice = JSON.parse(JSON.stringify(filteredManeuvers[Math.floor(Math.random() * filteredManeuvers.length)]))
                choice.id = Math.random() * 1000000000
                choices.push(choice)
            }
        }   

        return choices
    },

    rollStats(options, count){
        let choices = []
        let rarityArr = this.getOptionsArray(options.rarity)
        let types = this.getOptionsArray(options.type)
        for(let x = 0; x < count; x++){
            let rarity = this.getRarity(rarityArr, rarities)
            let type = this.getRarity(types, statRarities)
            let refinedPosibilities = stats.filter(possibility => possibility.rarity == rarity && type == possibility.type)
            let choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.ceil(Math.random() * refinedPosibilities.length-1)]))
            if (choice.stat == 'skill'){
                choice.stat = skills[Math.ceil(Math.random() * skills.length -1)].skill
            }
            if(choice.drawback){
                choice.penalty = choice.drawback.amount
                let possibleDrawbacks = drawbacks.filter(drawback => drawback.type == choice.drawback.type)
                choice.drawback = possibleDrawbacks[Math.ceil(Math.random() * possibleDrawbacks.length-1)].stat
            }
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },
    rollClass(count) {
        let choices = []        
        let previousRolls = []
        for(let x = 0; x < count; x++){
            let newRoll = this.unrepeatedRoll(classRoll.length, previousRolls)
            previousRolls.push(newRoll)
            let choice = JSON.parse(JSON.stringify(classRoll[newRoll]))
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },
    rollRace(count){
        let choices = []        
        let previousRolls = []
        for(let x = 0; x < count*2; x++){
            let newRoll = this.unrepeatedRoll(races.length, previousRolls)
            previousRolls.push(newRoll)
            let choice = JSON.parse(JSON.stringify(races[newRoll]))
            choice.id = Math.random()*10000000
            choices.push(choice)
        }
        return choices
    },
    rollGold(){
        
    },
    rollStore(){
        
    },
    rollAlignment(count){
        let choices = []        
        let previousRolls = []
        for(let x = 0; x < count; x++){
            let newRoll = this.unrepeatedRoll(alignments.length, previousRolls)
            //console.log("got final roll number", newRoll)
            previousRolls.push(newRoll)
            let choice = {name:alignments[newRoll]}
            choices.push(choice)
        }
        return choices
    },
    rollLoot(options) {
        let reward = {potions:[], gear:0}    
        let level = Math.floor(options.level / 2) - 1
        switch(options.size){
            case "small":
              reward.goldAmount = 120 + (Math.ceil(Math.random() * 10)*4)
              reward.potions = reward.potions.concat(this.rollPotions("curative", Math.floor(Math.random() * 2) + 1, level))
              reward.potions = reward.potions.concat(this.rollPotions("mnemonic", Math.floor(Math.random() * 3), level))
              reward.potions = reward.potions.concat(this.rollPotions("restorative", Math.floor(Math.random() * 2), level))
              if(Math.random() > 0.70 - level*2) reward.gear+= 1
              if(Math.random() > (0.95)){
                let options = {rarity:{common:true,rare:true}, type:{ring: true, neck:true, eyes:true, belt:true, hands:true, wrist:true, shoulders:true, chest:true, headband:true, body:true, feet:true, head:true,untyped:true}}
                reward.item = this.rollWonderousItems(options, 1)[0]
                reward.item.uiType = "wonderousItems"
              }   
            break
            case "medium":
                reward.goldAmount = 200 + (Math.ceil(Math.random() * 10)*8)
                reward.potions = reward.potions.concat(this.rollPotions("curative", Math.ceil(Math.random() * 3), level))
                reward.potions = reward.potions.concat(this.rollPotions("mnemonic", Math.ceil(Math.random() * 3), level))
                reward.potions = reward.potions.concat(this.rollPotions("restorative", Math.floor(Math.random() * 3), level))
                if(Math.random() > 0.25 - level*2) reward.gear += 1
                if(Math.random() > 0.75 - level*2) reward.gear += 1  
                if(level > 3){
                    reward.potions = reward.potions.concat(this.rollPotions("curative", Math.floor(Math.random() * 3), level -3))
                    reward.potions = reward.potions.concat(this.rollPotions("mnemonic", Math.floor(Math.random() * 3), level -3))
                }                
                if(level > 6){
                    reward.potions = reward.potions.concat(this.rollPotions("curative", Math.floor(Math.random() * 3), level -5))
                    reward.potions = reward.potions.concat(this.rollPotions("mnemonic", Math.floor(Math.random() * 3), level -5))
                }
                if(Math.random() > (0.60 - level)){
                    let options = {rarity:{common:true,rare:true,epic:true}, type:{ring: true, neck:true, eyes:true, belt:true, hands:true, wrist:true, shoulders:true, chest:true, headband:true, body:true, feet:true, head:true,untyped:true}}
                    reward.item = this.rollWonderousItems(options, 1)[0]
                    reward.item.uiType = "wonderousItems"
                }
                break
            case "large":
                reward.goldAmount = 400 + (Math.ceil(Math.random() * 10)*12)
                reward.potions = reward.potions.concat(this.rollPotions("curative", Math.floor(Math.random() * 3) + 1, level))
                reward.potions = reward.potions.concat(this.rollPotions("mnemonic", Math.floor(Math.random() * 3) + 1, level))
                reward.potions = reward.potions.concat(this.rollPotions("restorative", Math.floor(Math.random() * 3) + 1, level))
                reward.gear += Math.ceil(Math.random()*2)                
                if(Math.random() > 0.9) reward.potions = reward.potions.concat(this.rollPotions("ressurective", 1, level))
                if(level > 3){
                    reward.potions = reward.potions.concat(this.rollPotions("curative", Math.floor(Math.random() * 3), level -3))
                    reward.potions = reward.potions.concat(this.rollPotions("mnemonic", Math.floor(Math.random() * 3), level -3))
                    if(Math.random() > 0.7) reward.potions = reward.potions.concat(this.rollPotions("ressurective", 1, level))            
                }
                if(level > 6){
                    reward.potions = reward.potions.concat(this.rollPotions("curative", Math.floor(Math.random() * 3), level -5))
                    reward.potions = reward.potions.concat(this.rollPotions("mnemonic", Math.floor(Math.random() * 3), level -5))
                    if(Math.random() > 0.5) reward.potions = reward.potions.concat(this.rollPotions("ressurective", 1, level))
                }
                if(Math.random() > (0.30 - level)){
                    let options = {rarity:{common:true,rare:true,epic:true,legendary:true,unique:true}, type:{ring: true, neck:true, eyes:true, belt:true, hands:true, wrist:true, shoulders:true, chest:true, headband:true, body:true, feet:true, head:true,untyped:true}}
                    reward.item = this.rollWonderousItems(options, 1)[0]
                    reward.item.uiType = "wonderousItems"
                }
                break
          }
          return reward
    },
    rollPotions(options, count, level){
        let type
        if(options.type){
            type = options.type
            level = options.level
            if(options.ignoreLevel) level = Math.ceil(Math.random() * 9)
        }else{
            type = options
        }
        let potionsArray = []
        for(let x = 0; x < count; x++){
            if(type == "restorative"){
                if(level == 0) level = 1
                let possibilities = potions.filter(potion => potion.type == type && potion.minLvl <= level)
                if(Math.random() < 0.3){
                    possibilities = possibilities.filter(potion => potion.name.includes("Restoration"))
                }
                let potion = possibilities[Math.floor(Math.random() * possibilities.length)]
                potionsArray.push(potion)
            }else if(type != "ressurective"){
                let rarity = Math.random()
                if(rarity < 0.10) level -= 2
                else if(rarity < 0.25) level--
                else if(rarity > 0.75) level++
                if(rarity > 0.9) level++
                if(level > 9) level = 9
                if(level < 1) level = 1
                let possibilities = potions.filter(potion => potion.type == type && potion.minLvl == level)
                potionsArray.push(possibilities[0])
            }else{
                let possibilities = potions.filter(potion => potion.type == type && potion.minLvl <= level)
                let potion = possibilities[Math.floor(Math.random() * possibilities.length)]
                potionsArray.push(potion)
            }
        }
        return potionsArray
    },

    grearRarities: {
        common: 35,
        rare: 25,
        epic: 10,
        legendary: 5,
    },

    rollGear(options){        
        let types = this.getOptionsArray(options.type)
        let type = types[Math.floor(Math.random()*types.length)]
        let raratiesAvailable = ["common","rare","epic"]
        if(type == "utility"){
            raratiesAvailable.push("legendary")
        }
        let rarity = this.getRarity(raratiesAvailable, this.grearRarities)
        console.log("rarity: " + rarity)
        let refinedPosibilities = gear.filter(possibility => type == possibility.type && possibility.rarity == rarity)
        let item = JSON.parse(JSON.stringify(refinedPosibilities[Math.floor(Math.random()*refinedPosibilities.length)]))
        item.count = item.stack
        if(item.name == "Metamagic Implement"){
            item = this.rollMetamagicRod(item)              
        }
        if(item.name == "Masterwork Tool"){
            item = this.rollMasterworkTool(item)
        }
        return item
    },
    rollMetamagicRod(item){
        let feat = this.rollFeat({metamagic:true}, 1, null, null, null)
        item.name = feat[0].name.split(" ")[0] + " Metamagic Implement"
        item.longDesc += "\n\n" 
        item.longDesc += feat[0].longDesc.length != 0 ? feat[0].longDesc : feat[0].shortDesc
        return item
    },
    rollMasterworkTool(item){
        let nonKnowSkills = skills.filter(skill => !skill.skill.includes("know")) 
        let skill = nonKnowSkills[Math.floor(Math.random()*nonKnowSkills.length)]
        item.name = "Masterwork " + this.capitalize(skill.skill) + " Tool"
        item.skill = skill.skill
        return item
    },
    capitalize(str){  
        for(let x = 0; x < str.length; x++){
            if(str[x].toUpperCase() == str[x]){
                str = str.substring(0,x) + " " + str.substring(x,str.length)
                x++
            }
        }            
        let newStr = str[0].toUpperCase() + str.substring(1)
        return newStr
      },
    rollWonderousItems(options, count){
        let choices = []
        let rarityArr = this.getOptionsArray(options.rarity)
        let types = this.getOptionsArray(options.type)
        for(let x = 0; x < count; x++){
            let rarity = this.getRarity(rarityArr, rarities)
            let type = types[Math.floor(Math.random()* types.length)]
            let refinedPosibilities = wonderousItems.filter(possibility => possibility.rarity == rarity && possibility.type.includes(type))
            let choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.ceil(Math.random() * refinedPosibilities.length-1)]))
            if (choice.rolls){
                choice.stat = []
                if(choice.rolls[0] == "skill"){
                    choice.stat = skills[Math.ceil(Math.random() * skills.length -1)].skill
                    choice.name = choice.stat + " Gloves"
                    choice.name.replace("know", "Knowledge ")
                }else{
                    let physicalScores = ["strength","constitution","dexterity"]
                    let mentalScores = ["intelligence","wisdom","charisma"]
                    let allScores = ["strength","constitution","dexterity","intelligence","wisdom","charisma"]
                    choice.rolls.forEach(roll =>{
                        if(roll == "mental"){
                            let optionNum = Math.floor(Math.random()*mentalScores.length)
                            choice.stat.push(mentalScores[optionNum])
                            mentalScores.splice(optionNum, 1)
                        }else if(roll == "physical"){
                            let optionNum = Math.floor(Math.random()*physicalScores.length)
                            choice.stat.push(physicalScores[optionNum])
                            physicalScores.splice(optionNum, 1)
                        }else{
                            let optionNum = Math.floor(Math.random()*allScores.length)  
                            choice.stat.push(allScores[optionNum])
                            allScores.splice(optionNum, 1)
                        }
                    })
                }
            }
            if(choice.special){
                let feats = metamagic.filter(feat=> feat.cost == choice.special[1] && !feat.prereq)
                let feat = feats[Math.floor(Math.random()*feats.length)]

                choice.longDesc += `\n\n\n` + feat.name + `:\n` + feat.longDesc
            }
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },

    levelUp(options, count){
        let choices = []        
        for(let x = 0; x < count; x++){
            let rarityArr = this.getOptionsArray(options.rarity)
            let refinedPosibilities = []
            if(options.type == "abilityScore"){
                let rollOptions = {rarity:options.rarity, type:{abilityScore:true}}
                let choice = this.rollStats(rollOptions, 1)[0]                
                choices.push(choice)
                continue
            }else if(options.type == "skill"){
                let rarity = this.getRarity(rarityArr, rarities)
                refinedPosibilities = stats.filter(possibility => possibility.stat == "skill" && possibility.rarity == rarity)
            }else if(options.type == "save"){
                let rarity = this.getRarity(rarityArr, rarities)
                refinedPosibilities = stats.filter(possibility => ["reflex","fortitude","will"].includes(possibility.stat) && possibility.rarity == rarity)                
            }
            let choice = JSON.parse(JSON.stringify(refinedPosibilities[Math.ceil(Math.random() * refinedPosibilities.length-1)]))
            if(options.type == "save" && choice.drawback){
                choice.penalty = choice.drawback.amount
                let possibleDrawbacks = drawbacks.filter(drawback => drawback.type == choice.drawback.type)
                choice.drawback = possibleDrawbacks[Math.ceil(Math.random() * possibleDrawbacks.length-1)].stat
            }
            if (choice.stat == 'skill'){
                choice.stat = skills[Math.ceil(Math.random() * skills.length -1)].skill
            }
            choice.id = Math.random() * 1000000000
            choices.push(choice)
        }
        return choices
    },

    getRarity(rarityArr, rarityValues) {
        let rarityTotal = 0;
        let raritiesByChance = []
        rarityArr.forEach(rarity => {
            raritiesByChance.push({rarity, lowerEnd: rarityTotal, UpperEnd: rarityTotal + rarityValues[rarity]})
            rarityTotal += rarityValues[rarity]
        });
        let rarityRoll = Math.ceil(Math.random() * rarityTotal -1)
        let decidedRarity
        raritiesByChance.forEach((rarity)=>{
            if(rarityRoll >= rarity.lowerEnd && rarityRoll <= rarity.UpperEnd ){
                decidedRarity = rarity.rarity
            }
        })
        return decidedRarity
    },

    getLevelRarity(rarityArr) {
        rarityArr = rarityArr.sort(function(a, b){return a-b})
        let rarityValues = {}
        if(rarityArr.length <= 4){
            rarityValues[rarityArr[rarityArr.length-1]] = 25
            if(rarityArr[rarityArr.length-2]) rarityValues[rarityArr[rarityArr.length-2]] = 50
            if(rarityArr[rarityArr.length-3]) rarityValues[rarityArr[rarityArr.length-3]] = 15
            if(rarityArr[rarityArr.length-4]) rarityValues[rarityArr[rarityArr.length-4]] = 10
            return this.getRarity(rarityArr, rarityValues)
        }
        else{
            return this.getRarity(rarityArr, spellRarities)
        }
    },

    getOptionsArray(array){
        let stringArray = []
        Object.entries(array).forEach((entry) => {            
            if (entry[1] == true) {
                stringArray.push(entry[0])
            }
        })
        return stringArray
    },

    unrepeatedRoll(options, previousRolls){
        let currentRoll = Math.ceil(Math.random() * options-1)
        if(options-1 <= previousRolls.length -1){
            return currentRoll
        }
        while(previousRolls.includes(currentRoll)){
            currentRoll = Math.ceil(Math.random() * options-1)
        }
        return currentRoll
    }

}